import Vue from 'vue'
import Component from 'vue-class-component'
import StatementView from './StatementView.vue'
import convoStore from '../../store/convo/convo-store'
import { IConvo } from '../../model/convo'
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'convo-statements',
  props: ['convo'],
  components: {
    'statement-view': StatementView,
  },
})
export default class ConvoStatements extends Vue {
  mounted (): void {
    this.$store.subscribe((mutation, state) => {

      console.log('ConvoStatements mutation: type = %j', mutation.type)
      console.log('ConvoStatements mutation: payload = %j', mutation.payload)
      if (mutation.type.indexOf('setNumJybes') >= 0) {
        const convo: IConvo = this.$props['convo']
        console.log('ConvoStatements mutation: statement = %j', mutation.payload.statement.__ob__.value)
        if (convo.meta && convo.meta.statements) {
          console.log('ConvoStatements mutation: statements = %j', convo.meta.statements)
          if (convo.meta.statements.indexOf(mutation.payload.statement.__ob__.value) >= 0) {
            convoStore.dispatchFetchAllJybed(convo)
          }
        }
      }
    })
  }

  get buttonType():string {return authStore.isAuthenticated ? 'react' : 'nonauth'}

  react(convo: IConvo) {
  }
}
 